<template>
  <div class="page-wrap text-center">
    <div class="session-form-hold">
      <v-card :loading="pageLoading" class="rounded-lg">
        <v-card-text>
          <div class="d-flex align-center py-4">
            <v-img
              v-if="$vuetify.theme.dark"
              width="220"
              height="70"
              contain
              src="/img/logo/logo-dark.png"
              alt=""
            />
            <v-img
              v-else
              width="220"
              height="70"
              contain
              src="/img/logo/logo-light.png"
              alt=""
            />
          </div>
          <div v-if="!isAllowedDomain">
            <h3>Acesso restrito</h3>
            <p class="mb-4">
              O painel de administração da TiqOne só pode ser acessado pelo
              domínio oficial.
            </p>
            <v-btn
              href="https://admin.tiq.one"
              depressed
              color="primary"
              class="mt-4"
              block
            >
              Ir para o painel
            </v-btn>
          </div>
          <sign-in-form v-else-if="!pageLoading" />
        </v-card-text>
      </v-card>
      <!-- <v-btn v-if="!inPwa" class="mt-4" dark small text to="/">
        <v-icon left small>mdi-arrow-left</v-icon>
        Voltar para o site
      </v-btn> -->
    </div>
    <v-btn
      icon
      dark
      style="position: absolute; top: 1rem; right: 1rem"
      @click="toggleDarkMode"
    >
      <v-icon>{{
        $vuetify.theme.dark
          ? "mdi-lightbulb-on-outline"
          : "mdi-moon-waning-crescent"
      }}</v-icon>
    </v-btn>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SignInForm from "../../components/global/SignInForm.vue";
import { hidePoweredBy } from "@/themeConfig.js";

export default {
  components: { SignInForm },
  name: "SignIn",
  metaInfo: {
    title: "Acessar conta",
    // add     <meta http-equiv="Permissions-Policy" content='publickey-credentials-get=(self "https://example.com")'>
    meta: [
      {
        vmid: "permissions-policy", // um ID único para a meta tag, útil se precisar substituir ou identificar a tag
        httpEquiv: "Permissions-Policy",
        content:
          "publickey-credentials-get=(self 'https://atendimento.voytecnologia.com.br')",
      },
    ],
  },
  data() {
    return {
      loading: false,
      pageLoading: true,
      error: false,
      hidePoweredBy,
    };
  },
  methods: {
    ...mapActions(["changeThemeDarkMode"]),
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.changeThemeDarkMode(this.$vuetify.theme.dark);
    },
    redirect() {
      let to = this.$route.query.redirect || "/app";
      this.$router.push(to);
    },
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    isAllowedDomain() {
      const allowedDomains = [
        "admin.tiq.one",
        "localhost",
        "super.gpast.com.br",
        "admin.iw.tiq.one",
      ];
      const currentDomain = window.location.hostname;
      return allowedDomains.includes(currentDomain);
    },
  },
  mounted() {
    if (!!this.isAuthenticated) this.redirect();
    else return (this.pageLoading = false);
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}

.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
